import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { HotelSettingsHotelInfoDefaultContainer } from "@/components/features/hotel-info-settings/default/ui/components/container";

import { useGetParams } from "./hooks/use-get-params";

export const HotelInfoEditDefaultPage = () => {
	const { hotelID, navigator, activeLangCode } = useGetParams();

	return (
		<PageMeta title="施設情報の編集" url={generatePath(PATHS.HOTEL.HOTEL_SETTINGS.EDIT.DEFAULT, { hotelID })}>
			<HotelSettingsHotelInfoDefaultContainer
				hotelID={hotelID}
				navigator={navigator}
				activeLangCode={activeLangCode}
			/>
		</PageMeta>
	);
};

HotelInfoEditDefaultPage.displayName = "HotelInfoEditDefaultPage";
